import React from 'react';
import { Form, Formik } from 'formik';
import { ButtonTW } from '../../../../../../tailwindComponents/buttonTW/ButtonTW';
import { useSetRecipient } from './hooks/useSetRecipient';
import { RecipientSelect } from './RecipientSelect';

export const SetRecipientForm: React.FC<{
  onClose: () => void;
  children?: React.ReactNode;
}> = ({ children, onClose }) => {
  const { onSubmit, assignedCloser, validationSchema, initialValues, isLoading } = useSetRecipient(onClose);

  return (
    <>
      <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
        <Form id={'set-recipient-form'} data-test-id={'set-recipient-form'}>
          <RecipientSelect />
        </Form>
      </Formik>
      {children}
      <div className={'flex flex-row justify-end gap-4'}>
        <ButtonTW ghost secondary onClick={onClose}>
          Cancel
        </ButtonTW>
        <ButtonTW type={'submit'} form={'set-recipient-form'} disabled={!assignedCloser || isLoading}>
          Send
        </ButtonTW>
      </div>
    </>
  );
};
